import { Attachment } from '@/data/types/Product';
import {
  createContext,
  useContext,
  useRef,
  useState,
  useCallback,
} from 'react';
import type { Swiper as SwiperType } from 'swiper';

type VideoGalleryContextType = {
  actualVideo: Attachment | null;
  setActualVideo: React.Dispatch<
    React.SetStateAction<Attachment | null>
  >;
  isVideoPlayerActive: boolean;
  setIsVideoPlayerActive: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  swiperRefVideoGallery: React.MutableRefObject<SwiperType | null>;
};

export const VideoGalleryContext =
  createContext<VideoGalleryContextType | null>(null);

export const useVideoGallery = () => {
  const context = useContext(VideoGalleryContext);

  if (!context) {
    throw new Error(
      'useVideoGallery must be used within VideoGalleryProvider',
    );
  }

  return context;
};

export const VideoGalleryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [actualVideo, setActualVideo] =
    useState<Attachment | null>(null);

  const [isVideoPlayerActive, setIsVideoPlayerActive] =
    useState(false);

  const swiperRefVideoGallery =
    useRef<SwiperType | null>(null);

  return (
    <VideoGalleryContext.Provider
      value={{
        actualVideo,
        setActualVideo,
        isVideoPlayerActive,
        setIsVideoPlayerActive,
        swiperRefVideoGallery,
      }}
    >
      {children}
    </VideoGalleryContext.Provider>
  );
};